import React, { FC } from "react";
import { AvatarPlaceholderProps } from "./Avatar.types";
import classNames from "classnames";
import { AVATAR_SIZE_VARIANTS } from "./Avatar.constants";

export const AvatarPlaceholder: FC<AvatarPlaceholderProps> = ({
  size = "md",
  avatarPlaceholderClassNames,
}) => {
  return (
    <div
      className={classNames(
        "flex items-center justify-center rounded-full border-2 border-dashed border-gray-300",
        AVATAR_SIZE_VARIANTS[size],
        avatarPlaceholderClassNames,
      )}
    />
  );
};
